if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        this.hideErrors = this.dataset.hideErrors === 'true';

        this._isAddingSub = false;
      }

      getSubIdIfSelected() {
        const scope = document.querySelector('.susbscription-subscribe-options');
        if (!scope) return null;

        const input = scope.querySelector('input:checked:not(:disabled)');
        if (!input) return null;

        const subId = input.getAttribute('data-subid');
        const cleaned = String(subId || '').trim();
        return cleaned ? cleaned : null;
      }

      async fetchCart() {
        const res = await fetch('/cart.js', { credentials: 'same-origin' });
        return res.json();
      }

      isVariantInCart(cart, variantId) {
        const vid = Number(variantId);
        return (cart?.items || []).some((item) => Number(item.id) === vid);
      }

      async resolveProductIdToVariantId(productId) {
        try {
          const suggestUrl =
            `/search/suggest.json?q=${encodeURIComponent(productId)}&resources[type]=product&resources[options][fields]=id,handle&resources[options][limit]=10`;

          const suggestRes = await fetch(suggestUrl, { credentials: 'same-origin' });
          const suggestJson = await suggestRes.json();

          const products = suggestJson?.resources?.results?.products || [];
          const match = products.find((p) => String(p.id) === String(productId));

          if (!match || !match.handle) return null;

          const prodRes = await fetch(`/products/${match.handle}.js`, { credentials: 'same-origin' });
          const prodJson = await prodRes.json();

          const variants = prodJson?.variants || [];
          const firstAvailable = variants.find((v) => v.available) || variants[0];

          return firstAvailable?.id ? String(firstAvailable.id) : null;
        } catch (e) {
          return null;
        }
      }

      async addSubToCartSmart(subId, sectionsToRender, sectionsUrl) {
        if (!subId) return null;
        if (!this.cart) return null;

        if (this._isAddingSub) return null;
        this._isAddingSub = true;

        const tryAddVariant = async (variantId) => {
          const config2 = fetchConfig('javascript');
          config2.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config2.headers['Content-Type'];

          const fd2 = new FormData();
          fd2.append('id', variantId);
          fd2.append('quantity', '1');

          if (sectionsToRender && sectionsToRender.length) {
            fd2.append('sections', sectionsToRender);
            fd2.append('sections_url', sectionsUrl || window.location.pathname);
          }

          config2.body = fd2;
          const res = await fetch(`${routes.cart_add_url}`, config2);
          return res.json();
        };

        try {
          let cart = await this.fetchCart();

          if (this.isVariantInCart(cart, subId)) {
            return null;
          }

          let result = await tryAddVariant(subId);

          if (!result?.status) {
            this.cart.renderContents(result);
            return result;
          }

          const desc = String(result.description || result.message || '').toLowerCase();

          if (
            desc.includes('sold out') ||
            desc.includes('out of stock') ||
            desc.includes('not enough') ||
            desc.includes('inventory')
          ) {
            alert('Out of stock');
            return null;
          }

          if (desc.includes('cannot find') || desc.includes('variant')) {
            const resolvedVariantId = await this.resolveProductIdToVariantId(subId);
            if (!resolvedVariantId) return null;

            cart = await this.fetchCart();
            if (this.isVariantInCart(cart, resolvedVariantId)) {
              return null;
            }

            const result2 = await tryAddVariant(resolvedVariantId);

            if (result2?.status) {
              alert('Out of stock');
              return null;
            }

            this.cart.renderContents(result2);
            return result2;
          }

          return null;
        } catch (e) {
          return null;
        } finally {
          this._isAddingSub = false;
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        const subId = this.getSubIdIfSelected();

        const sectionsToRender = this.cart
          ? this.cart.getSectionsToRender().map((section) => section.id)
          : null;
        const sectionsUrl = window.location.pathname;

        if (this.cart) {
          formData.append('sections', sectionsToRender);
          formData.append('sections_url', sectionsUrl);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);

                    setTimeout(() => {
                      this.addSubToCartSmart(subId, sectionsToRender, sectionsUrl);
                    }, 80);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);

              setTimeout(() => {
                this.addSubToCartSmart(subId, sectionsToRender, sectionsUrl);
              }, 80);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
